import { BLINK_FLAGS, envFlags } from '@thoughtspot/env-flags';
import { LoadingIndicator } from '@thoughtspot/radiant-react/widgets/loading-indicator';
import React from 'react';
import { useAppContext } from '/@contexts/global-app-context';
import { useNavHubContext } from '/@contexts/nav-hub-context';
import { GetTseLicense } from '/@services/get-tse-license/tse-license-service';
import { NavPanel } from '../../microfrontends/embed-dev-portal';

// This componenet will be called in the callback fn of left nav hub for Develop tab
export const DevelopLeftNavContainer = () => {
    const { sessionService, blinkHooks } = useAppContext();
    const { tseOrgContext, setTseOrgContext } = useNavHubContext();
    const { data: tseLicense = {}, loading, error } = GetTseLicense();
    const tseLicenseLock =
        !error &&
        !tseLicense?.licenseEnforcementDisabled &&
        !tseLicense?.licenseEnabled &&
        (!tseLicense?.freeTrialEnabled || tseLicense?.daysLeft <= 0);
    const isSettingLocked =
        (!sessionService.hasAdminPrivileges() &&
            sessionService.isEverywhereSettingLocked()) ||
        envFlags.getValue(BLINK_FLAGS.everywhereSettingLocked?.name);

    if (loading && !error) {
        return (
            <LoadingIndicator.Global>
                <></>
            </LoadingIndicator.Global>
        );
    }

    return (
        <NavPanel
            rootPath="/develop/"
            isSettingLocked={isSettingLocked}
            tseLicenseLock={tseLicenseLock}
            currentContext={tseOrgContext}
            setCurrentContext={setTseOrgContext}
        />
    );
};

export default DevelopLeftNavContainer;
